import { createSelector } from 'reselect'
import isCurrentVariantAFreeSampleProductSelect from 'modules/gift/redux/selectors/is-current-variant-a-free-sample'
import isCurrentVariantADeluxeSampleProductSelect from 'modules/gift/redux/selectors/is-current-variant-a-deluxe-sample'
import getSizeGuideLabelProductSelectUtil from 'modules/product/redux/selectors/get-size-guide-label/utils'
import getSelectedVariantSelect from 'modules/variant/redux/selectors/get-selected-variant'
import isCurrentVariantAPaidSingleUseSampleProductSelect from 'modules/gift/redux/selectors/is-current-variant-a-paid-single-use-sample'

const getSizeGuideLabelGiftSelect = createSelector(
  isCurrentVariantADeluxeSampleProductSelect,
  isCurrentVariantAFreeSampleProductSelect,
  isCurrentVariantAPaidSingleUseSampleProductSelect,
  getSelectedVariantSelect,
  /**
   * @param isADeluxeSample
   * @param isAFreeSample
   * @param isAPaidSingleUseSample
   * @param {ProductVariantCollection} currentVariant
   * @return {*|string}
   */
  (
    isADeluxeSample,
    isAFreeSample,
    isAPaidSingleUseSample,
    currentVariant
  ) => {
    return getSizeGuideLabelProductSelectUtil({
      isADeluxeSample,
      isAFreeSample,
      currentVariant,
      isAPaidSingleUseSample,
      fullSizeOption: currentVariant?.size_option
    })
  }
)

export default getSizeGuideLabelGiftSelect
